import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { MatSidenav } from '@angular/material/sidenav';

import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-card-block',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  public isOpen: boolean[] = new Array(11).fill(true); // tots oberts per defecte

  constructor(private router: Router) { }

  ngOnInit() {  }

  ngOnDestroy(): void {  }

  go(lloc){this.router.navigate([lloc]);}

}
